<template>
  <div class="wrapper">
    <div class="warning">
      <AppIcon name="warning" size="body-l" />
      <p class="message">
        {{ $t('doc_reviewing.original_reference.warning') }}
      </p>
    </div>
    <p class="title">{{ $t('doc_reviewing.original_reference.title') }}</p>
    <p
      v-for="(paragraph, key) in originalParagraphs"
      :class="getParagraphClass(key)"
      :key="key"
    >
      {{ paragraph }}
    </p>
  </div>
</template>

<script setup lang="ts">
import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import { computed } from 'vue';

const props = defineProps<{
  originalParagraphs: Record<string, string>;
}>();

const keys = computed(() => Object.keys(props.originalParagraphs));

const getParagraphClass = (key: string) => {
  const isLast = key === keys.value[keys.value.length - 1];
  const hasBorder = !isLast && keys.value.length > 1;

  return {
    paragraph: true,
    border: hasBorder
  };
};
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  flex-direction: column;
  padding: $space-1;
  gap: $space-1;

  p {
    font-size: $body-s-font-size;
    line-height: $body-s-line-height;
  }
}

.warning {
  display: flex;
  flex-direction: row;
  gap: $space-2;
  padding: $space-2;
  align-items: center;
  border: 1px solid $color-warning-500;
  border-radius: $radius-2;
  background-color: $color-warning-100;
  color: $color-warning-900;

  .message {
    white-space: normal;
    overflow-wrap: break-word;
  }
}

.title {
  font-weight: $fw-medium;
  color: $color-text-darker;
  margin-top: $space-2;
}

.paragraph {
  &.border {
    padding-bottom: $space-1;
    margin-bottom: $space-2;
    border-bottom: 1px solid $color-neutral-200;
  }
}

// Styles for big screens
@media (min-height: $small-screen-height) {
  .wrapper {
    p {
      font-size: $body-m-font-size;
      line-height: $body-m-line-height;
    }
  }
}
</style>
